export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
/**
 * @param  {Array} items The list of items whose position will be updated
 * @param  {} positionKey The key to update (order, position, etc.)
 * @returns {Array}
 */
export const setItemsPosition = (items, positionKey) => {
  return items.map((item, index) => ({ ...item, [positionKey]: index }));
};

/**
 * @param  {String} orderBy The column to sort by
 * @param  {String} orderDirection The sort direction ("asc" or "desc")
 * @returns {Array}
 */
export const getSortingParam = (orderBy, orderDirection) => {
  return orderBy ? `${orderDirection === "asc" ? "" : "-"}${orderBy}` : "";
};

/**
 * Used to get the sorting parameter string for React-Table
 */
export const getSortString = sortBy => {
  return sortBy ? `${sortBy.desc ? "-" : ""}${sortBy.id}` : "";
};
